module.exports = __webpack_public_path__ + "static/media/2.170338b1.png";